angular.module('relivConference').run(
    [
        'relivConferenceDscMenu',
        function (
            relivConferenceDscMenu
        ) {
            relivConferenceDscMenu.inject();
        },
    ]
);
